import { useQuery } from "@tanstack/react-query";
import { USER_API } from "config";
import {
  COMMENT_LIST_POLL_MS,
  fetchAllDocumentComments,
} from "features/script-editor/fetchAllDocumentComments";
import { useAxios } from "hooks/useAxios";
import { projectCommentsKeys } from "queries/projectComments.keys";
import type { DocumentComment } from "features/script-editor/types";

export function useAllDocumentComments(
  projectId: string,
  documentId: string,
  enabled: boolean,
  filters: { status?: "open" | "resolved" } = {},
  /** Refetch every 30s; pass true only while the list is on screen. */
  poll = false
) {
  const axios = useAxios();

  return useQuery<DocumentComment[]>({
    enabled,
    queryKey: projectCommentsKeys.comments(projectId, documentId, filters),
    queryFn: async () => {
      const params: Record<string, string> = {};
      if (filters.status != null) {
        params.status = filters.status;
      }
      return fetchAllDocumentComments(
        (pageParams) =>
          axios.get(USER_API.getDocumentComments(projectId, documentId), { params: pageParams }),
        params
      );
    },
    staleTime: 30 * 1000,
    refetchInterval: enabled && poll ? COMMENT_LIST_POLL_MS : false,
  });
}
